export default {
  heading: 'Kulim Park, sans-serif',
  body: 'Lora, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Playfair Display, serif',
  googleFonts: ['Kulim Park:100,200,300,400,500,600,700,800,900', 'Lora:400,500,600,700,800,900']
  // customFamilies: ["Din"],
  // customUrls: ["https://www.gonation.biz/fonts/din/din.css"],
}
